import SectionHeading from "@/components/base/SectionHeading";
import { watchSteps } from "@/mocks/movie";

export default function WatchGuide() {
  return (
    <section id="guide" className="w-full bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-8 py-16 md:py-24">
        <SectionHeading
          eyebrow="How to Watch"
          title="观影指南：五步获得更好的观看体验"
          description="按照下面的顺序准备，可以最大程度还原这部作品的视听质感。"
        />

        <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {watchSteps.map((s, index) => (
            <div
              key={s.step}
              className="relative rounded-lg border border-background-200 bg-background-100 p-5 flex flex-col h-full"
            >
              <div className="flex items-center justify-between">
                <span className="w-11 h-11 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
                  <i className={`${s.icon} text-2xl`}></i>
                </span>
                <span className="font-heading text-3xl font-black text-background-300">
                  {s.step}
                </span>
              </div>
              <h3 className="mt-5 font-heading text-base font-bold text-foreground-950">
                {s.title}
              </h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{s.text}</p>
              {index < watchSteps.length - 1 && (
                <i className="hidden lg:block ri-arrow-right-line absolute -right-4 top-1/2 -translate-y-1/2 text-xl text-background-400"></i>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 rounded-lg overflow-hidden border border-primary-200 bg-primary-50 p-6 md:p-8 flex flex-col md:flex-row md:items-center justify-between gap-6">
          <div className="flex items-start gap-4">
            <span className="w-12 h-12 shrink-0 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
              <i className="ri-information-line text-2xl"></i>
            </span>
            <div>
              <p className="font-heading text-base md:text-lg font-bold text-foreground-950">
                关于资源来源的温馨提示
              </p>
              <p className="mt-1 text-sm text-foreground-600 leading-relaxed max-w-2xl">
                本站仅整理影片的剧情、主创与观影信息，方便观众按自己的习惯锁定内容。
                请在合法合规的渠道观看正版内容，注意甄别以“完整版”“独家”为名的诱导链接。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}